
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import partial from 'utils/partial'

export default class SelectGroup extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    values: PropTypes.array,
    selected: PropTypes.string,
    onSelect: PropTypes.func,
    disabled: PropTypes.bool
  }

  static defaultProps = {}

  render() {
    const {className, disabled} = this.props

    const classNames = classnames('select-group', className, {
      'is-disabled': disabled
    })

    return (
      <div className={classNames}>
        {this.renderSections()}
      </div>
    )
  }

  renderSections() {
    const {values, selected} = this.props

    return values.map((item, index) => {
      const {value, label} = item
      const classNames = classnames('select-group_item', {
        'is-active': value === selected
      })

      return (
        <div
          className={classNames}
          onClick={partial(this.onSelect, value)}
          key={index}
        >
          {label}
        </div>
      )
    })
  }

  onSelect = value => {
    const {onSelect, disabled} = this.props

    if (disabled) return null

    onSelect && onSelect(value)
  }
}



// WEBPACK FOOTER //
// ./client/components/SelectGroup/index.js